import {
  SIGN_IN_SUCCESS,
  SET_STUDENT_ID,
  SET_NOTIFICATION_LIST,
  SET_COUNTRIES_LIST,
  SET_USER_PERMISSIONS
} from 'modules/Auth/actions'

const initialState = {
  token: null,
  studentId: '',
  lastLocation: '/dashboard',
  notificationData: {},
  listOfCountries: [],
  permissions: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SIGN_IN_SUCCESS:
      return {
        ...state,
        token: action.token,
      }
    case SET_STUDENT_ID:
      return {
        ...state,
        studentId: action.id,
      }
    case SET_NOTIFICATION_LIST:
      return {
        ...state,
        notificationData: action.data,
      }
    case SET_COUNTRIES_LIST:
      return {
        ...state,
        listOfCountries: action.data,
      }
      case SET_USER_PERMISSIONS:
        return {
          ...state,
          permissions: action.data,
        }
    default:
      return state
  }
}
